export default {
	0: 'pending',
	1: 'enabled'
};